/* Table of Contents
==================================================

    #Slate Default
    #Custom Velstar

==================================================
*/

/* ==========================================================================
#Slate Default
========================================================================== */

window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Settings ================*/
//Create Vars that match SCSS breakpoints, defined in variables.scss.liquid file.
var screenSM = 576,
	screenMD = 768,
	screenLG = 992,
	screenXL = 1200;

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Templates ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        //$(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCart, this.$container).addClass('variant-available');
        $(selectors.addToCart, this.$container).removeClass('btn-disabled');
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        //$(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCart, this.$container).addClass('btn-disabled');
        $(selectors.addToCart, this.$container).removeClass('variant-available');
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
	});


/*
BG: persistentCheck: The idea being to constantly check (or persistently check) if target exists, if it does, pass in an additional function that will trigger once condition is true. If condition is never true, have a timeoutTime to stop checking. 
*/
function persistentCheck(target,targetValue,paramFunction,paramTarget,timeoutTime) {
    //console.log('persistentCheckFunction');
    var checkExist = setInterval(function() {
        //console.log('Persistently checking for: '+target);
    //keep checking to see if condition is true 

    if ($(target).length > targetValue) {
            //console.log('condition is true, will no longer check.');
            //check paramFunction is actually a function
            if (typeof paramFunction == "function") {
                paramFunction(paramTarget); 
            }
            //clear interval
            clearInterval(checkExist);
        }
    }, 100); // check every 100ms
    
    setTimeout(function(){
        //console.log('couldn\'t find target or condition wasn\'t true');
        clearInterval(checkExist);
    }, timeoutTime);
}


//BG: Init slickSlider for Recently Viewed and Related Products.
function slickSlider(target) {
    $(target).slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 2,
        arrows:true,
        dots: false,
        prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50 50'><rect fill='#EEEEEE' x='0' y='0' width='50' height='50'/><polygon fill='#0B2027' transform='translate(24.000000, 25.000000) rotate(-90.000000) translate(-24.000000, -25.000000)' points='24 22 29 28 19 28'/></svg></button>",
			  nextArrow:"<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50 50'><rect fill='#EEEEEE' x='0' y='0' width='50' height='50'/><polygon fill='#0B2027' transform='translate(24.000000, 25.000000) rotate(90.000000) translate(-24.000000, -25.000000)' points='24 22 29 28 19 28'/></svg></button>",
        responsive: [
            {
                breakpoint: 992,
                settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
            },
            {
                breakpoint: 768,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
            },
            {
                breakpoint: 480,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots:false
            }
            }
        ]
    });
}

//BG: The below function is used by both the Recently Viewed and Related Products. When looping through the products, we use the below as a template.
function outputProduct(data, outputLocation) {

  var imageRatioClass = $(outputLocation).attr('data-image-ratio');

  var productHTML = "";
      productHTML += '<div class="col-6 col-md-3 featured-product">';
        productHTML += '<div class="product-image">';
          productHTML += '<a href="/products/'+data.handle+'" title="'+data.title+'" class="'+imageRatioClass+'">';
            productHTML += '<img data-sizes="auto" data-src="'+slate.Image.getSizedImageUrl(data.featured_image,'400x')+'" data-srcset="'+slate.Image.getSizedImageUrl(data.featured_image,'400x')+' 400w, '+slate.Image.getSizedImageUrl(data.featured_image,'540x')+' 540w, '+slate.Image.getSizedImageUrl(data.featured_image,'720x')+' 720w, '+slate.Image.getSizedImageUrl(data.featured_image,'900x')+' 900w" alt="'+data.title+'" class="img-fluid lazyload" />';
          productHTML += '</a>';
          productHTML += '<span class="product-wishlist"><span class="smartwishlist" data-product="'+data.id+'" data-variant="'+data.variants[0].id+'"></span>';
        productHTML += '</div>';
        productHTML += '<div class="product-details">';
          productHTML += '<a href="/products/'+data.handle+'" title="'+data.title+'">';
            productHTML += '<span class="product-title">'+data.title+'</span>';
            //productHTML += '<span class="product-price"><span class="money">'+slate.Currency.formatMoney(data.price, theme.moneyFormat)+'</span></span>';
          productHTML += '</a>';
      productHTML += '</div>';
      productHTML += '</div>';

    $(outputLocation).find('.row.featured-products-slick').append(productHTML);
}

//BG: Grab the recently viewed products array, and loop through the products and output them.
function retrieveRecentlyViewedProducts(array,outputLocation,maxProducts) {

    //if the array is greater than max allowed products, delete the last product from the array.
    if (array.length > maxProducts) {
        array.shift();
    }
    
    // loop for the array, and output the products.
    $.each(array,function(i, product) {
        //ensure the product isn't undefined.
        if (product != "undefined.js") {
            //make a json request based on the product handle.
            var ajax = $.getJSON('/products/' + product, function(data) {
                //pass the data over to the below function
                outputProduct(data,outputLocation);
            });
        }

        //Check to see if it's the last item in the Array, if it is...
        var increment = i + 1;
        if (array.length == increment) {
            //Init slickSlider on recently viewed.
            persistentCheck('.featured-products.product-recently-viewed .featured-product',4,slickSlider,'.featured-products.product-recently-viewed .featured-products-slick',10000);
        }
	});
}

//BG: Add current product to the recently viewed array
function addNewProduct(array,productHandle,maxProducts) {

  //BG: if array is greater than the maxProducts, then delete the first item in the array
  if (array.length > maxProducts) {
    array.shift();
  }

  //BG: only add the product to the array, if it doesn't already exist
  if(array.indexOf(productHandle) == -1 && productHandle != "undefined.js") {
      array.push(productHandle);
  }
  //BG: Update localStorage
  localStorage.setItem("recentProductsNew", JSON.stringify(array));
}

//BG: Using localStorage, we create an array based on the products the user has been viewing. When they visit a product page, it stores the product handle. 
function recentlyViewedProducts() {
    //Retrieve localstorage for recentproducts(if it exists)
    var savedRecentProducts = JSON.parse(localStorage.getItem("recentProductsNew")),
        outputLocation = ".product-recently-viewed",
        newProduct = $(outputLocation).attr('data-product-handle');
        newProduct = newProduct + ".js",
        maxProducts = 8;

    //if localstorage exists, retrieve the list and output it
    if (savedRecentProducts) {
        retrieveRecentlyViewedProducts(savedRecentProducts,outputLocation,maxProducts);
        addNewProduct(savedRecentProducts,newProduct,maxProducts);
    } else {
        //First time user has visited a product page, so let's create the new local storage.
        //console.log('doesn\'t exist, let\'s make a new array');
        var recentProducts = [];
        addNewProduct(recentProducts,newProduct,maxProducts);
        //As this is the first time the customer has visited the product page, hide the recently viewed.
        $('.product-recently-viewed').addClass('d-none');
    }
}

//BG: Make the call to the related products API
function relatedProductsAPI() {
var productID = $('.featured-products.related-products').attr('data-product-id');

    //Make the JSON request to the recommendations API, pass over the current product ID.
    $.getJSON('/recommendations/products.json?product_id='+productID+'&limit=8', function(data) {
        //for each product in the API Response, pass over to the output function.
        $.each(data.products,function(i, product) {
            outputProduct(product,'.featured-products.related-products');

            var increment = i + 1;
            if (data.products.length == increment) {
                //Init slickSlider on related products
                persistentCheck('.featured-products.related-products .featured-product',4,slickSlider,'.featured-products.related-products .featured-products-slick',10000);
            }
        });
    });
}
  
//Get URL Parameter
function getUrlParameter(name) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	var results = regex.exec(location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

//BG: if variant parameter is available in the URL, change the selection based on this.
function changeProductByVariantID() {
	var variantID = getUrlParameter('variant');
	//console.log(variant);

    if (variantID) {
		$('.swatch [data-variant-id="'+variantID+'"]').find('input[type="radio"]').prop("checked", true);
		//console.log('test');
    }
}

//BG: Intended to work with the 'back in stock' app. Trigger via button
function notifyApp() {
  var soldOutBtn = $('.btn-add-to-cart.variant-not-available'),
      notifyBtn = $('.BIS_trigger');

      soldOutBtn.click(function(e){
        e.preventDefault();  
        notifyBtn.click();
      });
}

//BG: Intended to work with the 'back in stock' app. Trigger via soldout size label
function notifyAppTwo() {
  var soldOutLabel = $('.soldout > label'),
      notifyBtn = $('.BIS_trigger');

      soldOutLabel.click(function(e){
        e.preventDefault();  
        notifyBtn.click();
      });
}

//BG: Intended to work with the 'back in stock' app. Trigger when all sizes are soldout
function notifyNoSizes() {
  if (!$('.swatch-element').hasClass('available')) {
    $('.iStock-wrapper').css('display', 'block');
  }
}
	
  
  //Accordion Functionality.
function accordionToggle() {
	var accordionTitle = $('.accordion-title');
	
	$('.accordion-item.active .accordion-content').show();
	
	accordionTitle.click(function(){
		if ($(this).parent('.accordion-item').hasClass('active')) {
			$(this).parent('.accordion-item').removeClass('active');
			$(this).next('.accordion-content').slideUp();
		} else {
			
			$('.accordion-item').removeClass('active');
			$('.accordion-content').slideUp();
			
			$(this).parent('.accordion-item').addClass('active');
			$(this).next('.accordion-content').slideDown();
		}
	})
}

function sizeguideSelect() {
	var sizeTabs = $('.size-guide-frame .size-tabs li a'),
		sizeSelect = $('.size-guide-frame .size-tabs-select select'),
		sizeTable = $('.size-guide-frame table');

	$(sizeTabs).click(function(e){
		e.preventDefault();
		var tableOption = $(this).attr('data-option');

		$(sizeTable).removeClass('active');
		$(sizeTabs).parent('li').removeClass('active');

		$(sizeSelect).val(tableOption).change();

		$(this).parent('li').addClass('active');
		$('.size-guide-frame table[data-table="'+tableOption+'"]').addClass('active');
	});

	$(sizeSelect).on('change', function(){
		var tableOption = $(this).val();
		
		$(sizeTable).removeClass('active');
		$(sizeTabs).parent('li').removeClass('active');

		$('.size-guide-frame .size-tabs li a[data-option="'+tableOption+'"]').parent('li').addClass('active');

		$('.size-guide-frame table[data-table="'+tableOption+'"]').addClass('active');

	});

}

//Checks to see if any colours are in the related_colours element, if there are then show the main colours div.
function colourChecker() {
  var productColoursContainer = document.querySelector('.product-colours-detail');
  var productColours = document.querySelectorAll('.product-colours-detail li');

  if (productColours.length > 0) {
    //Shows main container
    productColoursContainer.classList.add('active');
  }
}

function sizeguideModal() {
    var closeIcon = $('.size-guide-frame .size-guide-close'),
		sizeguideOverlay = $('.size-guide-overlay'),
		sizeguideFrame = $('.size-guide-frame'),
		sizeguideOpen = $('.template-product .size-guide');

    $(closeIcon).click(function(){
        $(sizeguideFrame).removeClass('active');
        $(sizeguideOverlay).removeClass('active');
    })

    $(sizeguideOpen).click(function(){
        $(sizeguideFrame).addClass('active');
        $(sizeguideOverlay).addClass('active');
    })
}
	
//BG: Only run on Product Page.
if ($('body.template-product')) {

    changeProductByVariantID();
  	accordionToggle();
  	sizeguideSelect();
    sizeguideModal();
    recentlyViewedProducts();
    relatedProductsAPI();
    colourChecker();
    
    //BG: App related functions for Product Page
    persistentCheck('.BIS_trigger',0,notifyApp,'nothing',10000);
    persistentCheck('.BIS_trigger',0,notifyAppTwo,'nothing',10000);

  }

  return Product;
})();

/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
	  
	if ($(this).hasClass('address-new-primary')) {
		$(this).addClass('hide');
	}
	  
	if ($(this).hasClass('address-new-secondary')) {
		$('.address-new-primary').removeClass('hide');
	}
	  
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
	  
	if ($(this).hasClass('address-edit-primary')) {
		$(this).addClass('hide');
	}
	  
	if ($(this).hasClass('address-edit-secondary')) {
		$('.address-edit-primary').removeClass('hide');
	}
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

//Get URL Parameters 
function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

//create Cookie
function setCookie(name,value,days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days*24*60*60*1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

//Get cookie value
function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}

//Delete cookie
function eraseCookie(name) {
	document.cookie = name+'=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
}


function collectionReadMore() {
	var readmoreBtn = $('.collection-read-more'),
		collectionDescription = $('.collection-description .rte'),
		collectionDescriptionHeight = collectionDescription.height();
		//collectionNav = $('.collection-header .collection-sub-nav'),
		//collectionNavHeight = collectionNav.height();

		readmoreBtn.off('click').on('click', function(e){

		if (readmoreBtn.hasClass('active')) {

			// collectionNav.animate({
			// 	height: collectionNavHeight
			// }, 1000);

			collectionDescription.removeClass('active');

			collectionDescription.animate({
				height: collectionDescriptionHeight
			}, 1000, function(){
				readmoreBtn.removeClass('active');
			});

			readmoreBtn.text('Read More');

		} else {

			// collectionNav.animate({
			// 	height: collectionNav.get(0).scrollHeight
			// }, 1000, function(){
			// 	$(this).height('auto');
			// });

			collectionDescription.addClass('active');

			collectionDescription.animate({
				height: collectionDescription.get(0).scrollHeight
			}, 1000, function(){
				$(this).height('auto');
				readmoreBtn.addClass('active');
			});

			readmoreBtn.text('Read Less');

		}

	});
}

function collectionViews() {
	var collectionViewSelect = $('.collection-view li'),
		collectionView = $('#bc-sf-filter-products');

	if (getCookie('collectionView')) {
		collectionView.attr('class','row collection-view-six');
		collectionViewSelect.removeClass('active');
		$('.collection-view li.collection-view-six').addClass('active');
	}

	collectionViewSelect.click(function(){
		var collectionViewClass = $(this).attr('class').split(' ')[0];

		collectionViewSelect.removeClass('active');
		$(this).addClass('active');

		collectionView.attr('class','row '+collectionViewClass);

		if (collectionViewClass === 'collection-view-six' ) {
			setCookie('collectionView','six', 365)
		} else {
			eraseCookie('collectionView');
		}

	});
}

function filterToggle() {
	var filterTitle = $('.filter-title'),
		filterSidebar = $('.filter-sidebar');

	if ($(window).width() < screenLG) {
		filterTitle.removeClass('active');
		filterSidebar.css('display', '');
	}
	
	filterTitle.off('click').on('click', function(){
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			filterSidebar.slideUp();
		} else {
			$(this).addClass('active');
			filterSidebar.slideDown();
		}
	});
}

//BG: For each product, find the related product colour and link to it.
function collectionProductColours() {
	var collectionProducts = $('.collection-listing .product-single');

	//Loop through the product list, and get the productID for each product. The loop through the second list of products, and match them based on the productGroup.
	collectionProducts.each(function(){
	var productID = $(this).attr('data-product-id'),
		productGroup = $('.collection-product-colours li[data-product-id="'+productID+'"]').attr('data-product-group'),
		productGroupCollection = $('.collection-product-colours li[data-product-group="'+productGroup+'"]');

		//Loop through the product grouping, and append the products to their related grouping.
		productGroupCollection.each(function(){
			var thisProductID = $(this).attr('data-product-id'),
				thisProductColour = $(this).attr('data-product-colour'),
				thisProductImage = $(this).attr('data-product-image-large'),
				thisProductImageSecondary = $(this).attr('data-product-image-secondary'),
				thisProductURL = $(this).attr('data-product-url');

				if (thisProductID == productID) {
					thisProductColour = thisProductColour + " primary-product active";
				}

				var list = '<li class="'+thisProductColour+'" data-product-id="'+thisProductID+'" data-product-image="'+thisProductImage+'" data-product-image-secondary="'+thisProductImageSecondary+'" data-product-url="'+thisProductURL+'"></li>';

			//if product has colour....then append it.
			if (thisProductColour) {	
				if (thisProductID == productID) {
					$('.collection-listing .product-single[data-product-id="'+productID+'"] .product-colours ul').prepend(list);
				} else {
					$('.collection-listing .product-single[data-product-id="'+productID+'"] .product-colours ul').append(list);
				}
			}

			//if more than one colour, show colours.
			if ($('.collection-listing .product-single[data-product-id="'+productID+'"] .product-colours li').length > 1) {
				$('.collection-listing .product-single[data-product-id="'+productID+'"] .product-colours').removeClass('d-none');
			}
		});
	})
}

//BG: used in conjuction with the above function, once the above function has ran, we then need to allow the user to switch between the colours, and show image and update the product link.
function collectionProductColourSwitcher() {
	var productColours = $('.collection-listing .product-colours li'),
		interactionType = "";

	if ($(window).width() <= screenMD) {
		interactionType = "click";
	} else {
		interactionType = "mouseover";
	}

	productColours.on(interactionType, function() {
		var productImage = $(this).attr('data-product-image'),
			productImageSecondary = $(this).attr('data-product-image-secondary'),
			productURL = $(this).attr('data-product-url'),
			productID = $(this).attr('data-product-id'),
			parentProductID = $(this).closest('#product_single').attr('data-product-id'),
			productColours = $(this).closest('#product_single').find('.product-colours li'),
			primaryImage = $(this).closest('#product_single').find('.product-image img'),
			parentProductURL = $(this).closest('#product_single').find('a'),
			quickView = $(this).closest('#product_single').find('.product-quickview span');

			productColours.removeClass('active');
			$(this).addClass('active');

			primaryImage.attr('src', productImage);
			primaryImage.attr('data-second-image', productImageSecondary);
			parentProductURL.attr('href', productURL);
			quickView.attr('data-product-url', productURL);
	});
}

//On the initial page load, set the sorting option to the first option.
function sortFilter() {
	if (!getUrlParameter('sort')) {
		$( window ).one( "load", function() {
			$('#bc-sf-filter-top-sorting select option:first').attr("selected",true);
		});
	}
}

//On the initial page load, set the limit option to the first option.
function limitFilter() {
	if (!getUrlParameter('limit')) {
		$( window ).one( "load", function() {
			$('#bc-sf-filter-top-show-limit select option:first').attr("selected",true);
		});
	}
}

//BG: Changing the method of adding a second image. Rather than loading in the image as default, i'm loading in the URL to the second image, and will load it on hover.
function collectionProductHover() {
	$('.collection-listing .product-single .product-image img').on("mouseenter", function(){
		var firstImage = $(this).attr('data-src'),
			secondImage = $(this).attr('data-second-image');
			
			$(this).attr('data-src',secondImage);
			$(this).attr('src',secondImage);
			$(this).attr('data-srcset',secondImage);
			$(this).attr('srcset',secondImage);
			$(this).attr('data-second-image',firstImage);
	});
	$('.collection-listing .product-single .product-image img').on("mouseleave", function(){
		var secondImage = $(this).attr('data-src'),
			firstImage = $(this).attr('data-second-image');
			
			$(this).attr('data-src',firstImage);
			$(this).attr('src',firstImage);
			$(this).attr('data-srcset',firstImage);
			$(this).attr('srcset',firstImage);
			$(this).attr('data-second-image',secondImage);
	});
}

function backToTop() {
	$('.backToTop').on('click', function() {
		$("html, body").animate({ scrollTop: 0 }, "slow");
	});
}

collectionReadMore();
collectionViews();
filterToggle();
collectionProductHover();
backToTop();

//Update the quantity field on the cart page. Based on plus and minus buttons.
function cartQuantity() {
	var cartQuantity = $('.cart-product-quantity');

	
	cartQuantity.each(function(){
		var quantityUp = $(this).find('.quantity-up'),
			quantityDown = $(this).find('.quantity-down'),
			quantityValue = $(this).find('.cart-item__qty');
		
		
		quantityUp.on('click',function(){

			var currentVal = parseInt(quantityValue.val());
			if (!isNaN(currentVal)) {
				quantityValue.val(currentVal + 1);
			}
			$('.btn-cart-update').click();
		});
		quantityDown.on('click',function(){
			var currentVal = parseInt(quantityValue.val());
			if (!isNaN(currentVal) && currentVal > 1) {
				quantityValue.val(currentVal - 1);
			}
			$('.btn-cart-update').click();
		});
		
		quantityValue.bind('input',function() {
			$('.btn-cart-update').click();
		});
	});

}


function cartQuantitySelect() {
	var cartQuantity = $('.product-quantity');

	cartQuantity.each(function(){
		var quantitySelect = $(this).find('.product-quantity-select'),
			quantityValue = $(this).find('.product-quantity-value').attr('value'),
			quantityInput = $(this).find('.product-quantity-value');

		//On initial load, set the dropdown to reflect the current quantity.	
		quantitySelect.find('[value="'+quantityValue+'"]').attr('selected', true);

		// LM Once quantity has been changed, need to update input value beneath so checkout quanity is updated as well.
		quantitySelect.on('change', function(){
			var selectedValue = $(this).find(':selected').attr('value');
			var selectedInput = $(this).next();

			$(selectedInput).attr('value', selectedValue);
		});
	});
}

//cartQuantity();
cartQuantitySelect();
function forgotPassword() {

	var loginForm = $('#CustomerLoginForm'),
		passwordForm = $('#RecoverPasswordForm');

	$('.show-forgot-password').click(function(){
		loginForm.addClass('hide');
		passwordForm.removeClass('hide');
	});

	$('.hide-forgot-password').click(function(){
		loginForm.removeClass('hide');
		passwordForm.addClass('hide');
	});
}

function resetPasswordForm() {
	var formState = $('.reset-password-success')

	if (formState.length) {
		$('#ResetSuccess').removeClass('hide');
	}
}

function myAccount() {
	var myOrders =  $('.template-account a.account-my-order'),
		allOrders = $('.template-account .account-my-orders');

	$(myOrders).click(function(e){
		e.preventDefault();
		if (myOrders.hasClass('active')) {
			$(allOrders).slideUp( "slow", function() {
				myOrders.removeClass('active');
			});
		} else {
			$(allOrders).slideDown( "slow", function() {
				myOrders.addClass('active');
			});
		}
	});	
}

function showForgetPassword() {
	$('.forgotPassword').on('click', function(){
		console.log('example');
		$('#RecoverPasswordForm').slideDown();
	});
}

resetPasswordForm();
myAccount();
forgotPassword();
showForgetPassword();
function sidebarLinks() {
	var sidebarTitle = $('.sidebar-title'),
		sidebarContent = $('.sidebar-content');

	if ($(window).width() <= screenMD) {
		
		sidebarTitle.off('click').on('click', function(){
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				$(this).next('.sidebar-content').slideUp();
			} else {
				$(this).addClass('active');
				$(this).next('.sidebar-content').slideDown();
			}
		});
		
	} else {
		sidebarTitle.off('click');
		sidebarContent.css('display', '');
	}
}

sidebarLinks();

$(window).on('resize',function() {
    sidebarLinks();
});
function categoryToggle() {
	var categoryTitle = $('.categories-title'),
		categorySidebar = $('.categories-links');
	
	if ($(window).width() <= screenLG) {
		
		categoryTitle.off('click').on('click', function(){
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				categorySidebar.slideUp();
			} else {
				$(this).addClass('active');
				categorySidebar.slideDown();
			}
		});
		
	} else {
		categoryTitle.off('click');
		categorySidebar.css('display', '');
	}
}

function returnToBlog() {
	var blogTags = $('.blog-tags li a');

	if ($(blogTags).hasClass('active')) {
		$('.return-to-blog').removeClass('d-none');
	}
}

//categoryToggle();
returnToBlog();

$(window).on('resize',function() {
    //categoryToggle();
});
// LM: Function to remove click action on Swatch element - featured products.
function preventSwatch() {
	if($('body').hasClass('template-index')) {
		$('.swatch-element').on('click', function(event){
			event.preventDefault();
		});
	}
}

$(document).ready(function() {	
  preventSwatch();
});



/*================ Sections ================*/
// Used with sections/header-text-features.liquid
function textFeaturesSlick() {	
	$slick_slider = $('.text-features-slick');
	slicksettings = {
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: false,
		arrows: true,
		prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'><path d='M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z'/></svg></button>",
		nextArrow:"<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'><path d='M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z'/></svg></button>",
		responsive: [
		  {
			breakpoint: 768,
			settings: {
			  slidesToShow: 1
			}
		  },
		  {
			breakpoint: 576,
			settings: {
			  slidesToShow: 1
			}
		  }
		]
	}
	  
	if ($(window).width() < screenLG) {
		$slick_slider.slick(slicksettings);
	}
  
	// reslick only if it's not slick()
	$(window).on('resize', function() {
	   if ($(window).width() > screenLG) {
	 	if ($slick_slider.hasClass('slick-initialized')) {
	 	  $slick_slider.slick('unslick');
	 	}
	 	return
	   } else {
	 	  if (!$slick_slider.hasClass('slick-initialized')) {
	 		return $slick_slider.slick(slicksettings);
	 	  }
	   }
	});
}

$(document).ready(function() {	
    textFeaturesSlick();
});
//Open and close the mobile Search
function siteSearch() {
	var searchIcon = $('#site-header .header-search-icon'),
		searchBar = $('.search-bar');

	searchIcon.click(function(){
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			searchBar.slideUp();
		} else {
			$(this).addClass('active');
			searchBar.slideDown();
			searchBar.find('input').focus();
		}
	});
}

//Toggle open and close of mobile navigation
function mobileNavigationMenuToggle() {
	var menuIcon = $('#site-header .header-mobile-menu'),
		menuIconOpen = $('#site-header .mobile-menu-open'),
		menu = $('#site-navigation'),
		overlay = $('.nav-overlay');

	menuIcon.click(function(){
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			menuIconOpen.removeClass('active');
			menu.removeClass('active');
			overlay.removeClass('active');
			$('body').removeClass('no-scroll');

		} else {
			$(this).addClass('active');
			menuIconOpen.addClass('active');
			menu.addClass('active');
			overlay.addClass('active');
			$('body').addClass('no-scroll');
		}
	});

	menuIconOpen.click(function() {
		$(this).removeClass('active');
		menu.removeClass('active');
		menuIcon.removeClass('active');
		$('body').removeClass('no-scroll');
		overlay.removeClass('active');
	})

	overlay.click(function() {
		$(this).removeClass('active');
		menuIconOpen.removeClass('active');
		menu.removeClass('active');
		menuIcon.removeClass('active');
		$('body').removeClass('active');
	})
}

//Toggle open and close of the individual links within the navigation.
function mobileNavigation() {
	var parentLink = $('#site-navigation .has-child > a'),
		secondaryLink = $('#site-navigation .sub-menu-title'),
		tabLinks = $('#site-navigation .mobile-navigation-tabs ul li a'),
		primaryNavigation = $('#site-navigation .top-level'),
		secondaryNavigation = $('#site-navigation .account-navigation-links');
	
	if ($(window).width() <= screenLG) {
		//console.log('screenSM and Lower');
		
		//unbind and bind click action - can cause issues when resizing browser
		parentLink.off('click').on('click', function(e) {
			//print anchor from working.
			e.preventDefault();
			
			//add active class to parent and slide down child menus.
			if ($(this).parent('li').hasClass('active')) {
				$(this).next('.sub-menu-container').slideUp(400, function(){
					$(this).parent('li').removeClass('active');	
				});
			} else {
				parentLink.parent('li').removeClass('active');
				parentLink.next('.sub-menu-container').slideUp();
				$(this).next('.sub-menu-container').slideDown(400, function() {
					$(this).parent('li').addClass('active');
				});
			}
		});

		secondaryLink.off('click').on('click', function(e) {
			var link = $(this);
			if ($(this).hasClass('active')) {
				$(this).next('ul').slideUp(400, function(){
					link.removeClass('active');
				});
			} else {
				secondaryLink.removeClass('active').next('ul').slideUp();
				$(this).next('ul').slideDown(400, function(){
					link.addClass('active');
				});
			}
		});

		tabLinks.off('click').on('click', function(e){
			e.preventDefault();

			var hash = $(this).attr('href');
			
			if (hash == "#account") {
				primaryNavigation.addClass('d-none');
				secondaryNavigation.removeClass('d-none');
				$('#site-navigation .mobile-navigation-tabs ul li').removeClass('active');
				$(this).parent().addClass('active');
			} else {
				primaryNavigation.removeClass('d-none');
				secondaryNavigation.addClass('d-none');
				$('#site-navigation .mobile-navigation-tabs ul li').removeClass('active');
				$(this).parent().addClass('active');
			}

		});

		$('#site-navigation').addClass('transition');
		
	} else {
		parentLink.off('click');
		parentLink.next('.sub-menu').css('display', '');
		secondaryLink.off('click');
		secondaryLink.next('ul').css('display','');
		secondaryNavigation.addClass('d-none');
		primaryNavigation.removeClass('d-none');
		$('#site-navigation .mobile-navigation-tabs ul li').removeClass('active');
		$('#site-navigation .mobile-navigation-tabs ul li:first-of-type').addClass('active');
		
		$('#site-navigation').removeClass('active transition');
		$('.nav-overlay').removeClass('active');
		$('.header-mobile-menu').removeClass('active');
		$('body').removeClass('nav-push');
		//console.log('greater than screenSM');
		
	}
}

function desktopNavigation() {
	var mainNavigation = $('#site-navigation'),
		navOverlay = $('.nav-overlay'),
		parentLink = $('#site-navigation .has-child');
	
	if ($(window).width() >= screenLG) {
		//console.log('Screen LG & Greater');
		
		parentLink.on("mouseover", function() {
			$(this).addClass('active');  
			$(this).find('.menu').addClass('active');
			navOverlay.addClass('active');

			//UPDATE
			//BG: for performance reasons, we are now going to load the images within the mega menu when the user hovers on the menu.

			var navigationImages = $(this).find('.sub-menu-image img');
			navigationImages.each(function(){
				var imageURL = $(this).attr('data-image-url')
				if (imageURL) {
					$(this).attr('src',imageURL);
					$(this).removeClass('img-full');
				}
			});
		

		});
		
		parentLink.on("mouseout", function() {
			$(this).removeClass('active');  
			$(this).find('.menu').removeClass('active');
			navOverlay.removeClass('active');
		});

		
		
	} else {
		//console.log('Lower than Screen LG');
		mainNavigation.off("mouseover");
		mainNavigation.off("mouseout");
		parentLink.off("mouseover");
		parentLink.off("mouseout");
	}
}

//BG: Need to move the navigation when on mobile so it doesn't clash with the fixed header.
function moveNavigation() {

	var navigationContainer = $('.site-navigation-container'),
		bodyContainer = $('.body-container'),
		navOverlay = $('.nav-overlay'),
		navigation = $('#site-navigation');


	if ($(window).width() <= screenLG) {
		
		navigation.insertBefore(bodyContainer);
		navOverlay.insertBefore(bodyContainer);

	} else {
		navigationContainer.append(navigation);
		navOverlay.insertAfter('#MainContent');
	}
}

//BG: Because the header is fixed, we need to add padding to ensure nothing is hidden behind the header.
function headSpaceFix() {
	var headerTop = $('.header-top').outerHeight(true),
		header = $('#site-header').outerHeight(true);

	var headerHeight = headerTop + header;
	
	$('body').css('padding-top',headerHeight);
}

function headroom() {
	// grab an element
	var header = document.querySelector("header");
	var headerTop = document.querySelector(".header-top");
	// construct an instance of Headroom, passing the element
	var headroomHeader  = new Headroom(header, {
		"offset": 150
	});
	var headroomTopHeader  = new Headroom(headerTop, {
		"offset": 150
	});
	// initialise
	headroomHeader.init(); 
	headroomTopHeader.init();
}

function countrySelect() {
	var currentCountry = $('.current-country li');

	currentCountry.click(function(){
		$(this).toggleClass('active');
	});
	
}

function mobileNavHeight() {
	if ($(window).width() <= screenLG) {
		var headerheight = $('#site-header').innerHeight();

		$('.mobile-menu-open').css('height', headerheight);
		$('#site-navigation').css('top', headerheight);
	}
}

function cartShow() {
	var cartLink = $('.header-basket a');

	if ($(window).width() >= screenLG) {
		cartLink.off('click').on('click', function(event){
			if ($(this).hasClass('active')) {
				event.preventDefault();
				$(this).removeClass('active');
				$('.cart-mini-contents').removeClass('active');
				$('.nav-overlay').removeClass('active');
				$('body').removeClass('no-scroll');
			} else {
				event.preventDefault();
				$(this).addClass('active');
				$('.cart-mini-contents').addClass('active');
				$('.nav-overlay').addClass('active');
				$('body').addClass('no-scroll');
			}
		});
	}

	$('.cart-mini-contents .icon-close').on('click', function(){
		cartLink.removeClass('active');
		$('.cart-mini-contents').removeClass('active');
		$('.nav-overlay').removeClass('active');
		$('body').removeClass('no-scroll');
	});

	$('.nav-overlay').click(function() {
		$(this).removeClass('active');
		cartLink.removeClass('active');
		$('.cart-mini-contents').removeClass('active');
		$('body').removeClass('no-scroll');
	})
}

$(document).ready(function() {	
    siteSearch();
    mobileNavigationMenuToggle();
    mobileNavigation()
	desktopNavigation();
	headroom();
	headSpaceFix();
	moveNavigation();
	countrySelect();
	mobileNavHeight();
	cartShow();
});

$(window).on('resize',function() {
    mobileNavigation();
	desktopNavigation();
	headSpaceFix();
	moveNavigation();
	mobileNavHeight();
	cartShow();
});
function footerLinks() {
	var footerTitle = $('footer .footer-title:not(.nocollapse)'),
		footerContent = $('footer .footer-content');

	if ($(window).width() <= screenSM) {
		
		footerTitle.off('click').on('click', function(){
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				$(this).next('.footer-content').slideUp();
			} else {
				$(this).addClass('active');
				$(this).next('.footer-content').slideDown();
			}
		});
		
	} else {
		footerTitle.off('click');
		footerContent.css('display', '');
	}
}

footerLinks();

$(window).on('resize',function() {
    footerLinks();
});

/*================ Snippets ================*/
function quickviewVariant() {
	var variants = $('.product-quickview-frame .swatch-element'),
		variantInput = $('.product-quickview-frame .product-variant-id');

	$(variants).click(function(){
		var variantID = $(this).attr('data-variant-id');
		$(variants).removeClass('active');
		$(this).addClass('active');

		$(variantInput).attr('value',variantID);
	});

}

function quickviewSlick() {
	$('.product-quickview-frame .product-detail-images').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots:false,
		prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 6'><<path d='M9.89761404,4.89646707 L5.22905263,0.116407186 C5.16235088,0.0480359281 5.08561404,0.0137964072 4.99880702,0.0137964072 C4.912,0.0137964072 4.83512281,0.0480359281 4.76838596,0.116407186 L0.100210526,4.89646707 C0.0333333333,4.96494611 0,5.04352096 0,5.13244311 C0,5.22132934 0.0334385965,5.30001198 0.100210526,5.36834731 L0.600982456,5.88107784 C0.667754386,5.9494491 0.744596491,5.98365269 0.831403509,5.98365269 C0.918210526,5.98365269 0.995052632,5.9494491 1.06182456,5.88107784 L4.99880702,1.84986826 L8.93592982,5.88132934 C9.00266667,5.9497006 9.07954386,5.98365269 9.16621053,5.98365269 C9.25315789,5.98365269 9.33,5.94948503 9.39673684,5.88132934 L9.89757895,5.36838323 C9.96431579,5.3000479 9.99747371,5.22132934 9.99747371,5.13247904 C9.99747371,5.04352096 9.96435088,4.96483832 9.89761404,4.89646707 Z'/></svg></button>",
		nextArrow:"<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 6'><<path d='M9.89761404,4.89646707 L5.22905263,0.116407186 C5.16235088,0.0480359281 5.08561404,0.0137964072 4.99880702,0.0137964072 C4.912,0.0137964072 4.83512281,0.0480359281 4.76838596,0.116407186 L0.100210526,4.89646707 C0.0333333333,4.96494611 0,5.04352096 0,5.13244311 C0,5.22132934 0.0334385965,5.30001198 0.100210526,5.36834731 L0.600982456,5.88107784 C0.667754386,5.9494491 0.744596491,5.98365269 0.831403509,5.98365269 C0.918210526,5.98365269 0.995052632,5.9494491 1.06182456,5.88107784 L4.99880702,1.84986826 L8.93592982,5.88132934 C9.00266667,5.9497006 9.07954386,5.98365269 9.16621053,5.98365269 C9.25315789,5.98365269 9.33,5.94948503 9.39673684,5.88132934 L9.89757895,5.36838323 C9.96431579,5.3000479 9.99747371,5.22132934 9.99747371,5.13247904 C9.99747371,5.04352096 9.96435088,4.96483832 9.89761404,4.89646707 Z'/></svg></button>",
		arrows: true,
		fade: true,
	});
}

function quickviewAddToBasket() {
	$('.product-quickview-frame .btn-add-to-cart').click(function(){
		
		$('.product-quickview-frame form').submit(function (e) {
			e.preventDefault();
			addToCart($(this));
		});
	});
}

function quickView() {

	var quickViewBtn = $('.product-quickview .btn'),
		quickViewFrame = $('.product-quickview-frame'),
		quickViewOverlay = $('.product-quickview-overlay'),
		quickViewClose = $('.product-quickview-frame .frame-close'),
		quickViewProduct = $('.product-quickview-frame .product-frame');

	$(quickViewBtn).on( "click", function() {
		var productURL = $(this).attr('data-product-url'),
			productAvailability = $(this).attr('data-product-availability');

			console.log(productAvailability);

		quickViewFrame.addClass('active');
		quickViewOverlay.addClass('active');
		$('html,body').addClass('quickview-open');

		$.ajax({
			type: 'GET',
			url: productURL + '.json',
			dataType: 'json',
			success: function (data) {

				console.log(data);

				//if compare price (sale price) is available
				var productComparePrice = '';
				if (data.product.variants[0].compare_at_price > data.product.variants[0].price ) {
					productComparePrice = '<span class="product-price-original"><span class="money">' + data.product.variants[0].compare_at_price + '</span></span>';
				}


				//get product variants
				// var productVariants = '';
				// console.log(data.product.options.values);
				// console.log('yup');
				// $.each(data.product.options.values, function (i, variant) {
				// 	console.log('test' +vairant);
				// });

				//get product options (variant names)
				var productOptions = '';
				$.each(data.product.options, function (i, option) {
					
					//get product variants
					var productVariants = ''
					//loop through each variant
					$.each(option.values, function(i,variant) {

						var firstItem = '';
						if (i == 0) {
							firstItem = 'active';
						}

						productVariants += '<div data-value="'+ data.product.variants[i].title+'" data-variant-id="'+data.product.variants[i].id+'" class="swatch-element '+firstItem+'">'+data.product.variants[i].title+'</div>';
					});

					productOptions += '<div class="swatch swatch-'+option.name.toLowerCase()+'">' +
										'<div class="swatch-header">' +
											'Select a ' + option.name + '' +
										'</div>' +
										productVariants +	
									  '</div>'
				});

			
				//get images for products
				var quickviewImages = '';
				$.each(data.product.images, function (i, image) {
					quickviewImages += '<div class="product-image"><img src="'+ image.src +'" class="img-fluid" alt="'+ data.product.title +'"></div>';
				});

				//if product is available, show the available button, if product is sold out, show the sold out option.
				var addToCartButton = '';
				addToCartButton = '<button type="submit" name="add" data-add-to-cart="" class="btn-add-to-cart btn btn-secondary variant-available"><span data-add-to-cart-text="">Add to Bag</span></button>'; 

				

				//Build Markup output
var quickviewHTML = '<div class="container product-detail-container quickview-product-details">' +
					'<div class="row align-items-center">' +
					'<div class="col-12">' +
						'<div class="product-detail-images">' +
						quickviewImages + 
						'</div>' +  
					'</div><!-- Col - Image -->' +

					'<div class="col-12">' +
						'<h1 class="product-title text-center"><a href="/products/'+ data.product.handle+'">'+ data.product.title +'</a></h1>' + 
						'<div class="row align-items-sm-center text-center">' +
						'<div class="col-12">' + 
							'<div class="product-detail-price-wrapper">' +
							productOptions +
							productComparePrice +
							'<span class="product-detail-price">' +
								'<span class="money">'+ data.product.variants[0].price + '</span>' +
							'</span>' +
							'<form method="post" action="/cart/add">' +
							'<input min="1" type="number" id="quantity" name="quantity" value="1" class="d-none" />' +
							'<input type="hidden" name="id" class="product-variant-id" value="'+ data.product.variants[0].id + '" />' +	
							addToCartButton +	
							'</form>' +
						'</div><!-- col -->' +	
						'</div><!-- row -->' +
					'</div><!-- Col - Details -->' +

					'</div><!-- row -->' +
					'</div><!-- container -->';

					quickViewProduct.html(quickviewHTML);
					quickviewSlick();
					quickviewVariant();
					quickviewAddToBasket();
			}
		});

	});

	$(quickViewClose).click(function(){
		quickViewFrame.removeClass('active');
		quickViewOverlay.removeClass('active');
		quickViewProduct.html('');
		$('html,body').removeClass('quickview-open');
	});
}

quickView();
	/**
	 * Velstar Ajaxify Cart
	 **/
	var config = {

		/* Langauge */
		addToCartBtnText: 		'Add to Bag', //Add to Basket
		addedToCartBtnText: 	'Added to Basket', //Added to Basket
		addingToCartBtnText: 	'Adding', //Adding...
		soldOutBtnText: 		'Sold Out', //Sold Out
		//After adding a product to the cart, how long to wait before it returns to normal?
		returnBtnToNormal: 		4000, // milliseconds

		/* Selectors */
		cartCountSelector: 		'.cart-count',
		cartTotalSelector: 		'.mini-cart-total',
		cartRemoveSelector: 	'.cart-prod-remove',

		/* Icons*/
		successIcon: 			'<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-check" viewBox="0 0 512 512"><path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>',
		errorIcon: 				'<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-times" viewBox="0 0 352 512"><path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg>',
		loadingIcon: 			'<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-sync" viewBox="0 0 512 512"><path d="M500 8h-27.711c-6.739 0-12.157 5.548-11.997 12.286l2.347 98.575C418.212 52.043 342.256 8 256 8 134.813 8 33.933 94.924 12.296 209.824 10.908 217.193 16.604 224 24.103 224h28.576c5.674 0 10.542-3.982 11.737-9.529C83.441 126.128 161.917 60 256 60c79.545 0 147.942 47.282 178.676 115.302l-126.39-3.009c-6.737-.16-12.286 5.257-12.286 11.997V212c0 6.627 5.373 12 12 12h192c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12zm-12.103 280h-28.576c-5.674 0-10.542 3.982-11.737 9.529C428.559 385.872 350.083 452 256 452c-79.546 0-147.942-47.282-178.676-115.302l126.39 3.009c6.737.16 12.286-5.257 12.286-11.997V300c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12v192c0 6.627 5.373 12 12 12h27.711c6.739 0 12.157-5.548 11.997-12.286l-2.347-98.575C93.788 459.957 169.744 504 256 504c121.187 0 222.067-86.924 243.704-201.824 1.388-7.369-4.308-14.176-11.807-14.176z"></path></svg>',


		/* No need to change this elements. */
		addToCartBtnSelector: 	'.btn-add-to-cart.variant-available',
		addToCartFormSelector: 	'form[action="/cart/add"]',
		shopifyAjaxAddURL: 		'/cart/add.js',
		shopifyAjaxChangeURL: 	'/cart/change.js',
		shopifyAjaxCartURL: 	'/cart.js'
	}

//Provide the user Feedback if the Ajax was sucessful or not.
function ajaxFeedback(status, html, $addToCartForm) {
	//$('.ajaxfeedback').remove();
	var feedback = '<p class="ajaxfeedback ' + status + '">' + html + '</p>';

	$addToCartForm.find(config.addToCartBtnSelector).after(feedback);
	$('.ajaxfeedback').slideDown();
}

//BG: Provide the user feedback on the cart template when adjusting quantity / variant.
function ajaxFeedbackCart(status,html,output) {
	$('.ajaxFeedbackCart').remove();
	var feedback = '<span class="ajaxFeedbackCart '+status+'">'+html+'</span>';

	$(output).after(feedback);
}

//Update the button apperance during the various stages. Adding, added, and back to add.
function updateBtnText($button, label, icon) {
	if ($button.children().length) {
		$button.children().each(function () {
			if (icon) {
				if ($.trim($(this).text()) !== '') {
					$(this).html(label + icon);
				}
			} else {
				if ($.trim($(this).text()) !== '') {
					$(this).text(label);
				}
			}
		});
	} else {
		$button.val(label).text(label);
	}
}

//Format the money
function formatMoney(cents, format) {
	if (typeof cents == 'string') {
		cents = cents.replace('.', '');
	}
	var value = '';
	var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
	var formatString = (format || this.money_format);

	function defaultOption(opt, def) {
		return (typeof opt == 'undefined' ? def : opt);
	}

	function formatWithDelimiters(number, precision, thousands, decimal) {
		precision = defaultOption(precision, 2);
		thousands = defaultOption(thousands, ',');
		decimal = defaultOption(decimal, '.');

		if (isNaN(number) || number == null) {
			return 0;
		}

		number = (number / 100.0).toFixed(precision);

		var parts = number.split('.'),
			dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
			cents = parts[1] ? (decimal + parts[1]) : '';

		return dollars + cents;
	}

	switch (formatString.match(placeholderRegex)[1]) {
		case 'amount':
			value = formatWithDelimiters(cents, 2);
			break;
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0);
			break;
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',');
			break;
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', ',');
			break;
	}

	return formatString.replace(placeholderRegex, value);
};

//BG: Function to update the Cart Dropdown with the newly added product(s)	
function updateMiniCartContents() {

	//ajax get request to cart.js
	$.ajax({
		type: 'GET',
		url: config.shopifyAjaxCartURL,
		dataType: 'json',
		success: function (data) {

			//Debug
			//console.log(data);

			//Get Cart Total Cost (format it) & Cart Count. 
			var cartTotalCost = slate.Currency.formatMoney(data.total_price, theme.moneyFormat),
				cartCount = data.item_count;

			//Output cart total
			$(config.cartTotalSelector).html(cartTotalCost);
			$(config.cartCountSelector).text(cartCount);
			if (cartCount > 0) {
				$(config.cartCountSelector).removeClass('no-items');
			} else {
				$(config.cartCountSelector).addClass('no-items');
			}


			//remove all items within cart.
			$('.cart-mini-contents .cart-row .cart-item').remove();

			//with the returned data, focus soley on the items. For each item...
			$.each(data.items, function (i, item) {
				//debugging
				//console.log(item);

				var itemTitle = item.product_title;
				var itemPrice = slate.Currency.formatMoney(item.price, theme.moneyFormat);
				var itemQuantity = item.quantity;
				var itemVariant = item.variant_title;
				var itemVariantId = item.variant_id;
				var itemImage = item.image;
				var itemUrl = item.url;

				//add each product back to mini cart preview.
				$('.cart-mini-contents .cart-row').append('<div class="cart-item"><div class="cart-item-left"><div class="cart-prod-img"><a href="' + itemUrl + '"><img src="' + itemImage + '" class="img-fluid"></a></div></div><div class="cart-item-right"><div class="cart-prod-name"><a href="' + itemUrl + '">' + itemTitle + '</a></div><div class="cart-prod-price"><span class="money">' + itemPrice + '</span></div><div class="cart-prod-variant"><span>' + itemVariant + '</span></div><div class="cart-prod-quantity"><span class="label">Quantity:</span><span class="quantity-value">' + itemQuantity + '</span></div><div class="cart-prod-remove"><span data-variant-id="' + itemVariantId + '">Remove</span></div></div></div>');

			});

			//re-trigger the remove functionality.
			removeCartItemTrigger();
		}
	});
}

//remove product by setting quantity to zero via the data attribute.
function removeItemFromCart(variant_id) {
	//ajax get request to cart.js
	$.ajax({
		type: 'POST',
		url: config.shopifyAjaxChangeURL,
		data: 'quantity=0&id=' + variant_id,
		dataType: 'json',
		success: function (data) {

			//console.log('Remove Item Triggered');
			
			//Update the cart to reflect new contents.
			updateMiniCartContents();

		},
		error: function (XMLHttpRequest) {
			var response = eval('(' + XMLHttpRequest.responseText + ')');
			response = response.description;
			console.log(response);

		}
	});
}

//BG: Function will trigger on the cart page if user changes variant
function addItem(variant_id,quantity,old_variant_id) {
	$.ajax({
		type: 'POST',
		url: config.shopifyAjaxAddURL,
		data: 'quantity='+quantity+'&id=' + variant_id,
		dataType: 'json',
		success: function (data) {
			ajaxFeedbackCart('success','Updated size','.product-title[data-variant-id='+old_variant_id+'] .cart-product-variant-select');
		},
		error: function (XMLHttpRequest) {
			var response = eval('(' + XMLHttpRequest.responseText + ')');
			response = response.description;
		}
	});
}

//BG: function can be triggered by Quantity update, or variant update.
function quantityItemChange(variant_id,value,addProduct,new_variant_id,quantity) {
	//convert string to int
	var variant_id = parseInt(variant_id);

	//ajax get request to cart.js
	$.ajax({
		type: 'POST',
		url: config.shopifyAjaxChangeURL,
		data: 'quantity='+value+'&id=' + variant_id,
		dataType: 'json',
		success: function (data) {
			if (addProduct == 'add') {
				addItem(new_variant_id,quantity,variant_id);
			} else {
				$.each(data.items, function(index,item) {
					if (variant_id === item.variant_id) {
						if (item.quantity == value) {
							ajaxFeedbackCart('success','Quantity updated','.basket-item[data-variant-id='+variant_id+'] .product-quantity-select');

						//BG: if the amount has changed, but not to the value the user wanted.
						} else if (item.quantity < value) {
							ajaxFeedbackCart('warning','Quantity Updated to '+item.quantity+'. This is the last remaining amount.','.basket-item[data-variant-id='+variant_id+'] .product-quantity-select');
						}
						return false
					}
				});
			}

			//Update Total Price
			var cartTotalCost = slate.Currency.formatMoney(data.total_price, theme.moneyFormat);
			$('.basket-total-value span').html(cartTotalCost);
		},
		error: function (XMLHttpRequest) {
			var response = eval('(' + XMLHttpRequest.responseText + ')');
			response = response.description;
		}
	});
}




//Define the remove cart item selector, use the .off & .on feature to ensure it works correctly after new contents added to mini cart.
function removeCartItemTrigger() {
	//Remove Item from Cart
	$(config.cartRemoveSelector + ' span').off().on("click", function () {
		var varientID = $(this).attr('data-variant-id');

		$(this).parents('.cart-item').slideUp();
		
		//Pass over to removeItemFromCart Function.
		removeItemFromCart(varientID);

	});
}

function addToCart(form) {
		$('.ajaxfeedback').remove();
		//e.preventDefault();
		var $addToCartForm = form;
		var $addToCartBtn = $addToCartForm.find(config.addToCartBtnSelector+':first-of-type');

		//Adding button stage
		updateBtnText($addToCartBtn, config.addingToCartBtnText, config.loadingIcon);
		$addToCartBtn.addClass('btn-adding').prop('disabled', true);

		// Add to cart.
		$.ajax({
			url: config.shopifyAjaxAddURL,
			dataType: 'json',
			type: 'post',
			data: $addToCartForm.serialize(),
			success: function (itemData) {

				//Added button stage
				updateBtnText($addToCartBtn, config.addedToCartBtnText, config.successIcon);
				$addToCartBtn.removeClass('btn-adding').addClass('btn-added');

				//Once added, reset button back to add.
				window.setTimeout(function () {
					$addToCartBtn.prop('disabled', false).removeClass('btn-added');
					updateBtnText($addToCartBtn, config.addToCartBtnText);
				}, config.returnBtnToNormal);

				updateMiniCartContents();


				window.setTimeout(function () {
					//$('.header-basket .cart-icon').addClass('swing animated');
					$('.header-basket').addClass('hover');
				}, 1000);

				window.setTimeout(function () {
					$('.header-basket').removeClass('hover');
					//$('.header-basket .cart-icon').removeClass('swing animated');
				}, 4000);

				window.setTimeout(function () {
					var quickViewFrame = $('.product-quickview-frame'),
					quickViewOverlay = $('.product-quickview-overlay');

					quickViewFrame.removeClass('active');
					quickViewOverlay.removeClass('active');
					$('html,body').removeClass('quickview-open');
				}, 2500);
				
			},
			error: function (XMLHttpRequest) {
				var response = eval('(' + XMLHttpRequest.responseText + ')');
				response = response.description;
				if (response.slice(0, 4) === 'All ') {
					ajaxFeedback('error', response.replace('All 1 ', 'All '), $addToCartForm);
					$addToCartBtn.prop('disabled', false);
					updateBtnText($addToCartBtn, config.soldOutBtnText);
					$addToCartBtn.prop('disabled', true).removeClass('btn-adding').removeClass('btn-added');
				} else {
					ajaxFeedback('error', '<i class="fa fa-warning"></i> ' + response, $addToCartForm);
					$addToCartBtn.prop('disabled', false).removeClass('disabled');
					updateBtnText($addToCartBtn, config.addToCartBtnText);
				}

			}

		});
		return false;
}



//BG: allows the user to update the quantity and/or variant on the cart page.
function cartItemQuantityVariant() {
	var cartItem = $('.basket-item');

	cartItem.each(function(){
		var variantSelect = $(this).find('product-variant-select'),
			variantSelectValueOriginal = '',
			quantitySelect = $(this).find('.product-quantity-select'),
			quantitySelectId = quantitySelect.attr('data-variant-id'),
			quantitySelectValue = quantitySelect.val();

		variantSelect.on('focus', function(){
			variantSelectValueOriginal = $(this).val();
		});

		variantSelect.on('change', function(){
			var variantSelectValue = $(this).val();
			quantitySelectId = quantitySelect.attr('data-variant-id',variantSelectValue);
			quantityItemChange(variantSelectValueOriginal,0,'add',variantSelectValue,quantitySelectValue);

		});

		quantitySelect.on('change',function(){
			quantitySelectValue = $(this).val();
			quantitySelectId = quantitySelect.attr('data-variant-id');
			quantityItemChange(quantitySelectId,quantitySelectValue);
		})	
	});
}

$(document).ready(function() {

	if ($('body').hasClass('template-cart')) {
		//cartItemQuantity();
		//cartItemVariantSize();
		cartItemQuantityVariant();
	}
	
	removeCartItemTrigger();
	
	$(config.addToCartFormSelector).submit(function (e) {
		e.preventDefault();
		addToCart($(this));
	});
});

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});

/* ==========================================================================
#Custom Velstar
========================================================================== */


//product page swatch change
$('.swatch :radio').change(function() {
	var optionIndex = $(this).closest('.swatch').attr('data-option-index');
	var optionValue = $(this).val();
	$(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
});